export type DivisionFormValues = {
  divisionId: number;
};

export const unknownDivisionId = -1;
